import {
  faInfoCircle,
  faLock,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import { twMerge } from 'tailwind-merge'
import { Icon } from '../../Icon/Icon'

export type InputIconVariant = 'bordered' | 'centered' | 'unstyled'
export const InputIcon = (props: {
  invalid?: boolean
  hasPermission?: boolean
  loading?: boolean
  icon?: IconDefinition
  className?: string
  variant?: InputIconVariant
  iconPosition?: 'left' | 'right'
}) => {
  const position = props.iconPosition || 'left'
  const showSkeleton = typeof props.loading === 'boolean' && props.loading

  const containerClasses = twMerge(
    'flex items-center justify-center bg-transparent',
    props.variant === 'bordered' &&
      `bg-base-50 ${position === 'left' ? 'border-r' : 'border-l'}`,
  )

  if (
    typeof props.hasPermission === 'boolean' &&
    !props.hasPermission &&
    !props.loading
  )
    return (
      <div
        className={twMerge(
          containerClasses,
          'bg-amber-50 border-none text-base-700',
        )}>
        <Icon
          icon={faLock}
          className={twMerge(
            props.className,
            'text-amber-900/40 pl-2 bg-transparent',
          )}
        />
      </div>
    )

  if (props.invalid)
    return (
      <div className={containerClasses}>
        <Icon
          icon={faInfoCircle}
          className={twMerge(
            'pl-2',
            props.className,
            'text-red-400 bg-transparent',
          )}
        />
      </div>
    )

  if (!props.icon) return null

  if (showSkeleton)
    return (
      <div
        className={twMerge(
          containerClasses,
          'pl-2',
          props.variant === 'bordered' && 'pr-2',
        )}>
        <div className='h-5 w-5 animate-pulse rounded bg-slate-200 dark:bg-slate-800' />
      </div>
    )

  const iconClasses = twMerge('bg-transparent pl-2', props.className)

  if (props.variant === 'bordered')
    return (
      <div className={containerClasses}>
        <Icon
          icon={props.icon}
          className={twMerge('h-4! w-4! text-base-800 px-2', props.className)}
        />
      </div>
    )

  // if (props.variant === 'centered')
  return (
    <div className={containerClasses}>
      <Icon icon={props.icon} className={iconClasses} />
    </div>
  )

  return <Icon icon={props.icon} className={twMerge(iconClasses)} />
}
